import { defineComponent as _defineComponent } from 'vue'
import type { ICoursePreview } from "@/types/entities/ICoursePreview";
import { computed } from "vue";

interface Props {
  data: ICoursePreview;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CourseProgressBar',
  props: {
    data: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const completedStepsCount = computed<number>(() => {
  return Math.min(
    props.data.completedSteps.filter((s) => s !== "followup").length,
    5
  );
});

const fillProgressWidth = computed<number>(
  () => (completedStepsCount.value / 5) * 100
);

const __returned__ = { props, completedStepsCount, fillProgressWidth, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})